import React from 'react';

import AffinitiesBanner from './affinities-banner';
import BookLaunchBanner from './book-launch-banner';
import ChristmasBanner from './christmas-banner';
import FundraiserBanner from './fundraiser-banner';
import NewPrintsBanner from './new-prints-banner';
import PrintsShopBanner from './prints-shop-banner';
import PDIABanner from './pdia-banner';
import FlashMessageBanner from './flash-message-banner';

import '../../../styles/common/promos/sitewide-banner.scss';

const selectContents = (contents, path) => {
	switch (contents) {
    	case 'affinities':
			return (<AffinitiesBanner path={path} />);
		case 'book-launch':
			return (<BookLaunchBanner path={path} />);
		case 'fundraiser':
			return (<FundraiserBanner path={path} />);
		case 'christmas':
			return (<ChristmasBanner path={path} />);
		case 'new-prints':
			return (<NewPrintsBanner path={path} />);
		case 'prints-shop':
			return (<PrintsShopBanner path={path} hideOnMobile={true} />);
		case 'pdia':
			return (<PDIABanner path={path} />);
		case 'flash-message':
			return (<FlashMessageBanner path={path} />);
		default:
			return (<FundraiserBanner path={path} />);
	}
};

const SitewideBanner = (props) => (
	<>{selectContents(props.contents, props.path)}</>
);

export default SitewideBanner;
